<template>
  <div>
    <el-col :span="12">
      <el-button type="primary" @click="exportExcel()">导出</el-button>
    </el-col>
    <el-table :data="tableData" v-loading="tableLoading">
      <el-table-column label="序列号" prop="serialNumber" width="100"></el-table-column>
      <el-table-column label="测点编号" prop="ceDianBianHao" width="100" align="right"></el-table-column>
      <el-table-column label="模型" prop="moXingName"></el-table-column>
      <el-table-column label="湿密度(g/cm³)" prop="shiMiDu"></el-table-column>
      <el-table-column label="含水量(%)" prop="hanShuiLiang"></el-table-column>
      <el-table-column label="干密度(g/cm³)" prop="ganMiDu"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="getList" background :total="total" :page-size="pageSize" :current-page.sync="currentPage"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: null,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      companyName: "",
      tableLoading: false,
    };
  },
  methods: {
    getList() {
      let that = this;
      that.tableLoading = true;
      that.axios
        .post("WHMD08_Result/GetList", {
          onlyText: that.companyName,
          currentPage: that.currentPage,
          pageSize: that.pageSize,
        })
        .then(function (response) {
          that.total = response.data.data.total;
          that.tableData = response.data.data.data;
          that.tableLoading = false;
        });
    },
    handleDel(row) {
      let that = this;
      that.$confirm("确定要删除吗？").then(function () {
        that.axios
          .post("WHMD08_Result/DelModel", { onlyInt: row.id })
          .then(function () {
            that.getList();
          });
      });
    },
    exportExcel() {
      let that = this;
      that.axios.get("WHMD08_Result/ExportExcel").then(function (response) {
        open(process.env.VUE_APP_ExportFilePath + response.data.data);
      });
    },
  },
  mounted() {
    let that = this;
    that.getList();
  },
};
</script>

<style>
</style>